var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"play-list"},_vm._l((_vm.playlist_videos),function(video_3){return _c('div',{key:video_3.id.videoId},[_c('PlayListItem',{attrs:{"video_3":video_3}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }